<template>
  <section>
    <div class="row mb-2">
      <div class="col-md-3">
        <select class="form-select" v-model="msgType" @change="msgTypeChanged">
          <option
            v-for="msgType of msgTypes"
            :key="msgType.id"
            :value="msgType.value"
          >
            {{ msgType.name }}
          </option>
        </select>
      </div>
      <div class="col-md-5">
        <z-message
          v-model="message"
          :timeout="3000"
          class="alert alert-warning"
        />
      </div>
      <div class="col-md-4 custom-buttons">
        <div class="custom-buttons-wrap">
          <div v-if="isEdit" class="custom-save-buttons">
            <button class="btn btn-primary btn-sm" @click="setNew">
              <span>Reply</span>
            </button>
            <!-- <button
              v-if="isAdd"
              class="btn btn-primary btn-sm ms-1"
              @click="send"
            >
              <i class="far fa-save"></i>
              <span class="ms-2">Save</span>
            </button> -->
          </div>
          <!-- <button
            v-else
            class="btn btn-primary btn-sm ms-2"
            :disabled="isSending"
            @click="send"
          >
            <i v-if="isSending" class="fas fa-spinner fa-spin"></i>
            <i v-else class="fas fa-paper-plane"></i>
            <span class="ms-2">Send</span>
          </button> -->
        </div>
      </div>
    </div>
    <z-tabs
      v-model="currentTab"
      :tabs="tabs"
      :badges="badges"
      @change="showTab"
    />
    <div v-show="currentTab === 'Attachments'" class="row custom-tab">
      <div class="col-md-12">
        <file-upload
          ref="fileUploader"
          title=""
          subtitle=""
          instructions="Drag your files (in pdf, doc, png, or jpg format) here to begin or click to browse"
          :endpoint="endpoint"
          :id="orgId"
          :path="path"
          :folder="folder"
          :accept="accept"
          :key="uploadKey"
          :isShowSave="false"
          :isDontSave="true"
          :isShowList="true"
          :isReadonly="isEdit"
          :existingFiles="existingFiles"
          @filesAdded="filesAttached"
        />
      </div>
    </div>
    <div v-show="currentTab === 'Message'" class="row custom-tab">
      <div class="col-md-12">
        <div class="row mb-2">
          <div class="col-md-8" v-if="!isMultiple">
            <span class="me-3">To:</span>
            <img :src="avatar" class="custom-avatar" />
            <span class="ms-2">{{ sendTo }}</span>
          </div>
          <div class="col-md-4">
            <select class="form-select" v-model="tag" @change="tagChanged">
              <option
                v-for="tag of tags"
                :key="tag.id"
                :value="tag.value"
                :disabled="tag.disabled"
              >
                {{ tag.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="row">
          <div class="col-md-10 custom-date">
            <span>{{ msgDate }}</span>
          </div>
          <div class="col-md-2 custom-id">
            <span>{{ msgId }}</span>
          </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <editor
              ref="zEditor"
              @change="editorChange"
              @message="showMessage"
            />
          </div>
        </div>
      </div>
    </div>
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import ZInput from '@/Components/ZElements/Input'
import ZMessage from '@/Components/ZElements/Message'
import Editor from '@/Components/ZElements/Editor.vue'
import FileUpload from '@/Components/ZElements/Upload'
import ZTabs from '@/Components/ZElements/Tabs'
export default {
  name: 'wall-message',
  components: {
    ZInput,
    ZMessage,
    Editor,
    FileUpload,
    ZTabs,
  },
  props: {
    to: {
      type: Object,
      default: null,
    },
    view: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      body: '',
      msgTypes: [
        {
          id: 0,
          name: 'Regular Message',
          value: 'regular',
        },
        {
          id: 1,
          name: 'Activity Progress',
          value: 'recap_midweek',
        },
        {
          id: 2,
          name: 'Body Composition Progress',
          value: 'bodycomp_progress',
        },
        {
          id: 3,
          name: 'Nutrition Progress',
          value: 'nutrition_progress',
        },
      ],
      msgType: 'regular',
      tag: 'label',
      message: '',
      endpoint: 'api/v2/messages/attachments',
      uploadKey: 0,
      folder: '',
      path: '',
      accept: '',
      isSending: false,
      currentTab: 'Message',
      badges: [
        {
          name: 'Attachments',
          count: 0,
        },
      ],
      existingFiles: [],
    }
  },
  mounted() {
    this.init()
  },
  computed: {
    ...mapGetters('organizations', ['examineOrganization']),
    ...mapGetters('coaching', ['wallmessage', 'mergeTags']),
    tags() {
      let _tags = []
      if (this.mergeTags) {
        _tags = JSON.parse(JSON.stringify(this.mergeTags))
      }
      return _tags
    },
    isAdd() {
      let _data = true
      if (this.msgId !== null) {
        _data = false
      }
      return _data
    },
    tabs() {
      let _tabs = ['Message']
      // _tabs.push('Attachments')
      return _tabs
    },
    isMultiple() {
      let _data = false
      if (this.to !== undefined && this.to !== null) {
        if (this.to.id === undefined || this.to.id === null) {
          _data = true
        }
      }
      return _data
    },
    orgId() {
      let _data = null
      if (this.examineOrganization) {
        _data = this.examineOrganization.id
      }
      return _data
    },
    id() {
      let _data = null
      if (this.to) {
        _data = this.to.id
      }
      return _data
    },
    memberids() {
      let _data = null
      if (this.to) {
        _data = this.to.memberids
      }
      return _data
    },
    avatar() {
      let _data = null
      if (this.to) {
        _data = this.to.avatar
      }
      return _data
    },
    sendTo() {
      let _data = null
      if (this.to) {
        if (this.to.nickName !== '') {
          _data = `${this.to.lastName}, ${this.to.firstName} (${this.to.nickName})`
        } else {
          _data = `${this.to.lastName}, ${this.to.firstName}`
        }
      }
      return _data
    },
    msgDate() {
      let _data = moment().format('MM/DD/YYYY h:mm:ss a')
      if (this.wallmessage) {
        _data = moment(this.wallmessage.created).format('MM/DD/YYYY h:mm:ss a')
      }
      return _data
    },
    msgId() {
      let _data = null
      if (this.wallmessage) {
        _data = this.wallmessage.id
      }
      this.setMessage()
      return _data
    },
    isEdit() {
      let _data = false
      if (this.wallmessage) {
        if (this.wallmessage.id !== null) {
          _data = true
        }
      }
      return _data
    },
  },
  methods: {
    ...mapActions('coaching', ['saveWallMessage', 'setWallMessage']),
    init() {
      this.tag = 'label'
      this.msgType = 'regular'
      this.message = ''
      this.currentTab = 'Message'
      this.isSending = false
      this.badges = [
        {
          name: 'Attachments',
          count: 0,
        },
      ]
      this.existingFiles = []
    },
    showTab(value) {
      this.currentTab = value
    },
    messageBody() {
      let body = ''
      if (this.$refs.zEditor) {
        body = this.$refs.zEditor.getHTML()
        if (body === '' || body === '<p><br></p>') {
          body = ''
        }
      }
      return body
    },
    showMessage(msg) {
      this.message = msg
    },
    setMessage() {
      if (this.$refs.zEditor) {
        this.$refs.zEditor.setHTML(null)
        if (this.wallmessage) {
          this.$refs.zEditor.setHTML(this.wallmessage.text)
          this.setAttachments()
        }
      }
    },
    setAttachments() {
      if (this.wallmessage) {
        if (this.wallmessage.attachments) {
          if (this.wallmessage.attachments !== '') {
            let attachList = JSON.parse(this.wallmessage.attachments)
            this.existingFiles = []
            attachList.forEach((element) => {
              if (element.Uri !== '') {
                let segments = element.Uri.split('/')
                let filename = segments[segments.length - 1]
                this.existingFiles.push({
                  name: filename,
                  url: element.Uri,
                })
              }
            })
            this.badges[0].count = this.existingFiles.length
          }
        }
      }
    },
    msgTypeChanged() {
      console.log('Message Type Changed', this.msgType)
    },
    tagChanged() {
      console.log('Tag Selected', this.tag)
      this.$refs.zEditor.insertText(this.tag)
      this.tag = 'label'
    },
    editorChange(event) {
      let isValid = false
      let body = this.messageBody()
      if (body !== '') {
        isValid = true
      }
      console.log('Editor changed, valid?', {
        isValid: isValid,
        change: event,
      })
      this.$emit('valid', isValid)
    },
    attach() {
      console.log('Attaching File')
    },
    setNew() {
      this.currentTab = 'Message'
      this.existingFiles = []
      this.badges[0].count = 0
      this.setWallMessage(null)
      this.$emit('setNew')
    },
    filesAttached(numfiles) {
      this.badges[0].count = numfiles
    },
    async send() {
      this.message = ''
      let attachments = ''
      let files = await this.$refs.fileUploader.save()
      if (files) {
        files.forEach((element) => {
          if (attachments !== '') {
            attachments += ';'
          }
          attachments += element.FileName
        })
      }
      let recipients = ''
      if (this.isMultiple) {
        this.memberids.forEach((element) => {
          if (recipients !== '') {
            recipients += ';'
          }
          recipients += element.user_id
        })
      }
      let body = this.messageBody()
      if (body !== '') {
        this.isSending = true
        this.$emit('valid', true)
        this.$emit('sending', true)
        let data = {
          messageId: this.msgId,
          RecipientIds: this.isMultiple ? recipients : this.id,
          Body: body,
          msgType: this.msgType !== 'regular' ? this.msgType : null,
          images: files,
          orgId: this.examineOrganization.id,
        }
        try {
          console.log('Sending Wall Message', data)
          let response = await this.saveWallMessage(data)
          if (response.exception) {
            alert(`Error: ${response.message}`)
            this.isSending = false
            this.$emit('sending', false)
          } else {
            this.msgType = 'regular'
            if (this.$refs.zEditor) {
              this.$refs.zEditor.setHTML(null)
            }
            this.badges[0].count = 0
            this.isSending = false
            this.$emit('valid', false)
            this.$emit('sending', false)
            this.$emit('sent')
          }
        } catch (e) {
          alert(`Error: ${e.message}`)
          this.isSending = false
          this.$emit('sending', false)
        }
      } else {
        this.message = 'Please supply message text.'
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-avatar {
  border-radius: 50%;
  width: 40px;
  height: 40px;
}
.custom-buttons {
  text-align: right;
}
.custom-date {
  text-align: left;
  span {
    font-size: 0.7em;
  }
}
.custom-id {
  text-align: right;
  span {
    font-size: 0.7em;
  }
}
.custom-tab {
  padding: 10px;
}
.custom-save-buttons {
  display: inline;
}
.custom-buttons-wrap {
  padding: 5px;
}
.custom-switch {
  display: inline;
  padding-left: 0;
  label {
    float: left;
    top: 5px;
    left: 5px;
    position: relative;
    font-size: 0.9em;
  }
  .form-check-input[type='checkbox'] {
    height: 25px;
    width: 50px;
    margin-left: -1.2em;
  }
  .custom-badge {
    top: -5px;
    position: relative;
  }
}
</style>
